<label class="container">
  Erweiterten Modus aktivieren
  <input type="checkbox" [checked]="checked" (change)="toggleEditable($event)">
  <span class="checkmark"></span>
</label>
